var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton && _vm.previousPath)?_c('router-link',{staticClass:"btn text-light",attrs:{"to":_vm.previousPath}},[_c('fa',{attrs:{"icon":"arrow-left"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }